import { render, staticRenderFns } from "./InviteAddDialog.vue?vue&type=template&id=18854bac&scoped=true"
import script from "./InviteAddDialog.vue?vue&type=script&lang=js"
export * from "./InviteAddDialog.vue?vue&type=script&lang=js"
import style0 from "./InviteAddDialog.vue?vue&type=style&index=0&id=18854bac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18854bac",
  null
  
)

export default component.exports